import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useState, useEffect } from 'react'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { format, startOfDay, endOfDay } from 'date-fns'
import { useQueryState, parseAsString } from 'nuqs'
import useQueryGetPlayerWithDailyCheckInReceive from '@/modules/manage-player/api/hooks/useQueryGetPlayerWithDailyCheckInReceive'
import PlayerWithDailyCheckInReceiveListing from '@/modules/manage-player/components/PlayerWithDailyCheckInReceive/components/PlayerWithDailyCheckInReceiveListing'

type SortOrder = 'asc' | 'desc' | undefined

function PlayerWithDailyCheckInReceivePage() {
	const { pageSize, currentPage, searchQuery, channelFilter } =
		useTablePagination()
	const { dateFilter, setDateFilter } = useDateFilter()
	const [dateRange, setDateRange] = useQueryState(
		'dateRange',
		parseAsString.withDefault(''),
	)

	useEffect(() => {
		if (!dateFilter.startDate && !dateFilter.endDate && dateRange !== 'all') {
			const today = new Date()
			setDateFilter({
				startDate: format(startOfDay(today), 'yyyy-MM-dd'),
				endDate: format(endOfDay(today), 'yyyy-MM-dd'),
			})
			setDateRange('today')
		}
	}, [
		dateFilter.startDate,
		dateFilter.endDate,
		dateRange,
		setDateFilter,
		setDateRange,
	])

	const [dailyCheckInAmountSort, setDailyCheckInAmountSort] =
		useState<SortOrder>('desc')
	const [dailyCheckInTimeSort, setDailyCheckInTimeSort] = useState<SortOrder>()

	const handleSort = (columnId: string, order: SortOrder) => {
		if (columnId === 'totalDailyCheckInAmount') {
			setDailyCheckInAmountSort(order)
			setDailyCheckInTimeSort(undefined)
		} else if (columnId === 'totalDailyCheckInTime') {
			setDailyCheckInTimeSort(order)
			setDailyCheckInAmountSort(undefined)
		}
	}

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		phone: searchQuery,
		channelName: channelFilter || undefined,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
		dailyCheckInAmountSort,
		dailyCheckInTimeSort,
	}

	const { data, isLoading } = useQueryGetPlayerWithDailyCheckInReceive(payload)

	return (
		<PageContainer>
			<PlayerWithDailyCheckInReceiveListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
				onSort={handleSort}
			/>
		</PageContainer>
	)
}

const GuardedPlayerWithDailyCheckInReceivePage = withUserPermission(
	PlayerWithDailyCheckInReceivePage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.MANAGE_PLAYER],
	},
)

export default GuardedPlayerWithDailyCheckInReceivePage
